<div class="printable">
  <authority-labs-base-certificate-details
    [order]="order"
    [project]="project"
    [subProject]="subProject"
    [company]="company"
    [contact]="contact"
    [assignee]="assignee"
    [approval]="approval"
    [inspection]="inspection"
    [systemDescription]="'מתקני תברואה – בדיקת כיבוי אש – ברזי שריפה'"
  ></authority-labs-base-certificate-details>

  <div class="page-break"></div>

  <authority-labs-fire-taps-test-results
    [inspection]="inspection.inspectionFireTaps"
  >
  </authority-labs-fire-taps-test-results>

  <authority-labs-certificate-water-network-characterization
    *ngIf="
      inspection?.inspectionFireTaps?.waterNetworkCharacterization?.isApplicable
    "
    [inspection]="inspection?.inspectionFireTaps?.waterNetworkCharacterization"
    [inspectionDate]="inspection?.inspectionDate"
  >
  </authority-labs-certificate-water-network-characterization>

  <authority-labs-certificate-end-line></authority-labs-certificate-end-line>
</div>
